import { atom as atomJotai } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { ManipulatorState } from 'lib/generated/proto/bosdyn/api/robot_state';

import { DeviceName } from 'types/models';

/**
 * Additional state published if an arm is attached to the robot.
 *
 * Reflects the state coming from the robot.
 * Note: currently not all information we receive are stored related to missing parser
 * We use the concept of Proto but what we receive are ros-messages
 * */
export const manipulatorStateAtom = atomFamily(
  () => {
    const atom = atomJotai(ManipulatorState.create());
    atom.debugLabel = 'Relay Topics/Manipulator State Atom';
    return atom;
  },

  // custom value comparator to reproduce how Recoil worked (for complex values use fast-deep-equal)
  (a: DeviceName, b: DeviceName) => a === b,
);
